import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getUserAvatarSrc } from '../User/helpers';
import AvatarImage from '../User/AvatarImage';
import s from './GroupCard.scss';
const GroupCard = ({ group, className, biData })=>{
    var _getUserAvatarSrc;
    return /*#__PURE__*/ React.createElement(BiLink, {
        href: Url.userLink(group.username),
        className: classnames(s['root'], 'ds-card', className),
        biData: biData
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['img-wrap']
    }, /*#__PURE__*/ React.createElement(AvatarImage, {
        isGroup: true,
        enableLazyLoad: true,
        src: (_getUserAvatarSrc = getUserAvatarSrc(group)) !== null && _getUserAvatarSrc !== void 0 ? _getUserAvatarSrc : undefined
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, group.username));
};
GroupCard.displayName = 'GroupCard';
export default GroupCard;

//# sourceMappingURL=GroupCard.js.map